/* eslint-disable no-console */
import Config from './Config';

const R = require('ramda');

class AudioElement {
  constructor() {
    this.breakTune = null;
    this.ring = null;
    this.beep = null;
    this.currStatus = false;
  }

  loadAudio(playRing = false) {
    console.log("Load audio", playRing)
    if (this.ring === null) {
      try {
        // console.info('%c Loading Audio Files', 'color: grey;');
        const beepTone = `${R.prop('soundURL', Config)}beep_beep_beep.mp3`;
        const ringTone = `${R.prop('soundURL', Config)}FrontM_Ring.mp3`;
        this.ring = new Audio(ringTone);
        this.beep = new Audio(beepTone);
        this.ring.loop = false;
        this.beep.loop = false;

        if(playRing) {
          this.toggleLoop(true);
          this.ringToneWithInterval();
        }

      } catch (error) {
        console.error('Failed to load audio files:', error);
        this.ring = null;
        this.beep = null;
      }
    }
  }

  toggleLoop(val) {
    if (!this.ring) return;
    // this.ring.loop = val;
    this.currStatus = val;
  }

  ringToneWithInterval() {
    this.breakTune = setInterval(() => {
      if (this.currStatus === true) {
        this.ring.play();
        // this.ringToneWithInterval();
      }
    }, 5000);
  }

  playRing() {
    console.log("playRing recived", this.ring);
    if (!this.ring) {
      this.loadAudio(true);
    }
    if (!this.ring) return;
    // this.ring.play().catch((error) => {
    // console.error("Cannot play Ring Audio", error);
    // });

    this.ringToneWithInterval();
  }

  pauseRing() {
    clearInterval(this.breakTune);
    if (!this.ring) return;
    this.ring.pause();
  }

  playBeep() {
    if (!this.beep) return;
    this.beep.play().catch((error) => {
      console.error('Cannot play ring', error);
    });
  }

  pauseBeep() {
    if (!this.beep) return;
    this.beep.pause();
  }

  disableSound() {
    this.ring = null;
    this.beep = null;
  }
}

export default new AudioElement();
